import { custom } from "./custom";
import * as any from "./any/index";
import * as form from "./form/index";
import * as list from "./list";
export const FORM_INFOS = {
  any,
  form,
  list,
  custom
};
//# sourceMappingURL=index.js.map
